import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ForgotpasswordForm } from '@/modules/auth/components/forgot-password';
import { Button } from '@/components/ui-kit/button';
import { LOGIN_COLORS } from '@/modules/auth/constants/login-theme';

export const ForgotPasswordPage = () => {
  const { t } = useTranslation();

  return (
    <div className="flex w-full flex-col gap-6">
      <div className="flex flex-col gap-1.5">
        <h2
          className="text-[2rem] font-bold leading-tight tracking-tight sm:text-[2.125rem]"
          style={{ color: LOGIN_COLORS.textPrimary }}
        >
          {t('FORGOT_YOUR_PASSWORD')}
        </h2>
        <p className="text-sm font-normal leading-5" style={{ color: LOGIN_COLORS.textMuted }}>
          {t('ENTER_YOUR_REGISTERED_EMAIL')}
        </p>
      </div>
      <ForgotpasswordForm />
      <Link to="/login">
        <Button
          className="h-12 w-full rounded-xl border-0 text-sm font-semibold shadow-none"
          size="lg"
          variant="ghost"
          style={{ color: LOGIN_COLORS.primary }}
        >
          {t('GO_TO_LOGIN')}
        </Button>
      </Link>
    </div>
  );
};
